var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "rounded-lg" },
    [
      _c("v-card-title", [_vm._v("100ms.live Settings")]),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c("div", { staticClass: "text-h5 mb-4" }, [
            _vm._v("API Connection"),
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("p", [
                    _vm._v(
                      "100ms is the backend service provider that empowers the audio and video services. It's free to create an account and it comes with 10,000 free video conference minutes each month. Recording is billed at $0.016/minute. If you need more than 10,000 minutes, you will receive an invoice each month for minutes over 10,000 and all recording minutes. Additional meeting minutes are $0.004. "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-8",
                      attrs: {
                        href: "https://dashboard.100ms.live/register",
                        target: "_blank",
                        color: "primary",
                      },
                    },
                    [
                      _vm._v(" Create Free Account "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("mdi-open-in-new"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c("v-responsive", { attrs: { "aspect-ratio": 16 / 9 } }, [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                      },
                      attrs: {
                        src: "https://www.loom.com/embed/c4f7c0e04f6d40019e1974cfcf0facad",
                        frameborder: "0",
                        webkitallowfullscreen: "",
                        mozallowfullscreen: "",
                        allowfullscreen: "",
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", [
            _vm._v(
              'Once you have your account, log in and go to the "Developer" menu on the left in your 100ms.live account. Locate the "App Access Key" and "App Secret", then copy and paste those values here, and save your changes.'
            ),
          ]),
          _c("v-text-field", {
            attrs: {
              loading: _vm.loading,
              type: "password",
              outlined: "",
              label: "100ms App Access Key",
            },
            model: {
              value: _vm.settings.app_access_key,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "app_access_key", $$v)
              },
              expression: "settings.app_access_key",
            },
          }),
          _c("v-text-field", {
            attrs: {
              loading: _vm.loading,
              type: "password",
              outlined: "",
              label: "100ms App Secret",
            },
            model: {
              value: _vm.settings.app_secret,
              callback: function ($$v) {
                _vm.$set(_vm.settings, "app_secret", $$v)
              },
              expression: "settings.app_secret",
            },
          }),
          _c("div", { staticClass: "text-h6" }, [_vm._v("Enable Webhook")]),
          _c("p", [
            _vm._v(
              "In order to get your recordings, you'll need to enable the webhook option on the developer section and copy and paste this URL into the Webhook URL field:"
            ),
          ]),
          _c(
            "v-alert",
            { attrs: { prominent: "", type: "info" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", { staticClass: "grow" }, [
                    _vm._v(
                      " https://" +
                        _vm._s(_vm.domain) +
                        "/wp-json/dialer-now/meeting/webhook "
                    ),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "shrink" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.copyURL(
                                `https://${_vm.domain}/wp-json/dialer-now/meeting/webhook`
                              )
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-content-copy")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "ma-2",
              attrs: { loading: _vm.saving, color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveSettings()
                },
              },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }